import React, { useEffect, useState } from "react";
import "./kpiFilter.css";
import { Typography } from "@mui/material";
import {
  getDefaultKPITitle,
} from "../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices";
import KPIFilterItem from "./kpiFilterItem/KPIFilterItem";
interface KPIFilterProps {
  userConfig : Record<string, any>[];
  defaultConfigGlobal : Record<string, any>[];
  selectedKPIsKeys: string[];
  setSelectedKPIsKeys: (keys: string[]) => void;
}
// todo : if item is unselectd but expanded , and theni am selecgting it, it is closing and then opening , fix this bug 
const KPIFilter: React.FC<KPIFilterProps> = ({
  defaultConfigGlobal,
  userConfig,
  selectedKPIsKeys,
  setSelectedKPIsKeys,
}) => {
  const [checkedItems, setCheckedItems] = useState<Record<string, boolean>>(
   {}
  );

  const handleCheckboxChange = (id: string) => {
    const newCheckedItems = {
      ...checkedItems,
      [id]: !checkedItems[id],
    };
    setCheckedItems(newCheckedItems);

    // Update the selected keys
    let newSelectedKeys = [...selectedKPIsKeys];
    if (newCheckedItems[id]) {
      if (!newSelectedKeys.includes(id)) {
        newSelectedKeys.push(id);
      }
    } else {
      newSelectedKeys = newSelectedKeys.filter((key) => key !== id);
    }

    setSelectedKPIsKeys(newSelectedKeys);
  };
  useEffect(()=>{
    const kpiKeysSelected = selectedKPIsKeys.reduce((acc, key) => {
      acc[key] = true;
      return acc;
    }, {} as Record<string, boolean>)
    setCheckedItems(kpiKeysSelected);
  },[selectedKPIsKeys])
    return (
    <div className="kpi-filter-container">
<div style={{padding:"8px 8px 8px 10px", backgroundColor:"#f9fafc",}} >
  <Typography
          sx={{
            color: "black",
            fontSize: { xs: "1rem", md: "1rem", xl: "2rem" },
            fontWeight: "600",
      
          }}
        >
          KPI filter
        </Typography>
        </div>
      <div className="kpi-filter">
        {userConfig.map((kpi) => (
          <KPIFilterItem
            key={kpi["id"]}
            id={kpi["id"]}
            title={getDefaultKPITitle(kpi["id"],defaultConfigGlobal)}
            selected={checkedItems[kpi["id"]] || false}
            handleCheckboxChange={handleCheckboxChange}
          />
        ))}
      </div>
    </div>
  );
};

export default KPIFilter;
